import { QueryClient } from '@tanstack/react-query';
import { UploadedDocument } from '@urbanx/agx-ui-components';
import { AutopilotTaskDto, TaskCategoryTaskType } from '@urbanx/agx.activities.client';
import {
  DocumentTypes,
  UploadedDocument as CampaignUploadedDocument,
} from '@urbanx/agx.campaigns.client';

export enum ConnectionState {
  NotConnected,
  Connecting,
  Connected,
  Reconnecting,
  Disconnected,
}

export enum NotificationType {
  PdfProcessedEvent = 'PdfProcessedEvent',
  ReadyForDocuSignEvent = 'ReadyForDocuSignEvent',
  CampaignUpdatedEvent = 'CampaignUpdatedEvent',
  RexListingCreatedEvent = 'RexListingCreatedEvent',
  ContractStageUpdatedEvent = 'ContractStageUpdatedEvent',
  TaskUpdatedNotification = 'TaskUpdatedNotification',
  TaskCreatedNotification = 'TaskCreatedNotification',
  TaskDeletedNotification = 'TaskDeletedNotification',
  TaskCollectionChangedNotification = 'TaskCollectionChangedNotification',
  ContractDocumentUpdatedNotification = 'ContractDocumentUpdatedNotification',
}

export interface PushNotification {
  registerEvent: (
    eventType: string,
    callback: (event: NotificationEvents, queryClient: QueryClient) => void,
    id?: (string | undefined)[]
  ) => void;
  unregisterEvent: (
    eventType: string,
    eventCallback: (event: NotificationEvents) => void,
    id?: (string | undefined)[]
  ) => void;
}

export interface PdfProcessedEvent {
  campaignId: string;
  formId: string;
  uploadedDocument: UploadedDocument;
}

export interface CampaignUpdatedEvent {
  campaignId: string;
  agencyId: string;
}

export interface RexListingCreatedEvent {
  campaignId: string;
  agencyId: string;
  rexListingId: number;
}

export interface ContractStageUpdatedEvent {
  campaignId: string;
  agencyId: string;
  contractId: string;
}

export interface TaskUpdatedNotification {
  task: AutopilotTaskDto;
  collectionStateChanged: boolean;
}

export interface TaskCreatedNotification {
  taskId?: string;
  campaignId?: string;
  taskType?: TaskCategoryTaskType;
  contractId?: string;
  assignee?: string;
  dueUtc?: string;
  isLocked?: boolean;
}

export interface TaskDeletedNotification {
  taskId: string;
  campaignId: string;
  contractId?: string;
}

export interface TaskCollectionChangedNotification {
  campaignId: string;
  contractId?: string;
}

export interface ContractDocumentUpdatedNotification {
  campaignId: string;
  contractId: string;
  documentType: DocumentTypes;
  document: CampaignUploadedDocument;
}

export type NotificationEvents = PdfProcessedEvent &
  CampaignUpdatedEvent &
  RexListingCreatedEvent &
  ContractStageUpdatedEvent &
  TaskUpdatedNotification &
  TaskCreatedNotification &
  TaskDeletedNotification &
  TaskCollectionChangedNotification &
  ContractDocumentUpdatedNotification;
